/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { InfoDisplayStyles, infoDisplayStylesTwo } from "@eisinc/App/SharedStyles/InfoDisplayStyles";
import { CityStatePostalCode } from "@eisinc/Overrides/Components/AddressInfoDisplay";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import React from "react";

export interface SalesOfficeProps {
    salesOfficeData: string;
    clickable?: boolean;
}

const styles: InfoDisplayStyles = infoDisplayStylesTwo;

export const SalesOffice: React.FC<SalesOfficeProps> = ({ salesOfficeData, clickable }) => {
    if (!salesOfficeData) {
        return null;
    }

    const salesOffice = JSON.parse(salesOfficeData);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsRepInfo">
                {salesOffice.Name}
            </Typography>
            {salesOffice.Address1 && (
                <Typography {...styles.contentText} ellipsis={true} as="p">
                    {salesOffice.Address1}
                </Typography>
            )}
            {salesOffice.Address2 && (
                <Typography {...styles.contentText} ellipsis={true} as="p">
                    {salesOffice.Address1}
                </Typography>
            )}
            {(salesOffice.City || salesOffice.State || salesOffice.PostalCode) && (
                <CityStatePostalCode
                    city={salesOffice.City}
                    state={salesOffice.State}
                    postalCode={salesOffice.PostalCode}
                    styles={styles}
                />
            )}
            {salesOffice.Email && (
                <Typography {...styles.contentText} as="p" ellipsis={true}>
                    {clickable && (
                        <Link href={`mailto:${salesOffice.Email}`} target="_blank">
                            {salesOffice.Email}
                        </Link>
                    )}
                    {!clickable && salesOffice.Email}
                </Typography>
            )}
            {salesOffice.Phone && (
                <Typography {...styles.contentText} as="p" ellipsis={true}>
                    {clickable && (
                        <Link href={`tel:${salesOffice.Phone}`} target="_blank">
                            {salesOffice.Phone}
                        </Link>
                    )}
                    {!clickable && salesOffice.Phone}
                </Typography>
            )}
            {salesOffice.Url && (
                <Typography {...styles.contentText} as="p">
                    <Link href={salesOffice.Url} target="_blank">
                        {salesOffice.Url}
                    </Link>
                </Typography>
            )}
        </StyledWrapper>
    );
};
